import { styled } from '@compiled/react';
import FullWidthContainer from '@atlassian/jira-common-components-full-width-container/src/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const ContentContainer = styled(FullWidthContainer)({
	padding: '0 40px',
	maxHeight: '75vh',
	minHeight: '40vh',
	overflowY: 'auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export const KbContentContainer = componentWithCondition(
	getWillShowNav4,
	ContentContainer,
	FullWidthContainer,
);
